module.exports = __webpack_public_path__ + "static/img/logo.efce1f9.png";